import { NOTIFICATIONTYPE } from "Store/Notification/ActionTypes";
import { ACTION_TYPE, getActionTypes } from "Store/Shared/Actions/Helpers";
import ACTIONS from "./ActionTypes";

export const fetchEntities = (): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.FETCH_ENTITIES),
    shouldCallAPI: state => state.settings.entities._forceFetch,
    callAPI: {
        url: '/api/settings/entities'
    }
});

export const patchEntity = (entity, body): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.PATCH_ENTITY),
    callAPI: {
        method: 'PATCH',
        url: `/api/settings/entities/${entity}`,
        body: body
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    }
});